import type { ApproverDto } from "common/models/api/models/ApproverDto";
import type { CreateApproverDto } from "common/models/api/models/CreateApproverDto";
import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { releaseStrategyApi } from "../api/releaseStrategyApi";

export default function useCreateApprover(
    options?: UseCustomMutationOptions<ApproverDto, unknown, CreateApproverDto>,
): UseMutationResult<ApproverDto, unknown, CreateApproverDto> {
    return useMutation(async (body: CreateApproverDto) => {
        const res = await releaseStrategyApi.createApprover(body);
        return res.data;
    }, options);
}
